import { injectable } from 'inversify';
import { IVerifiedSuggestion } from 'src/interfaces/verified';
import { IVerifiedApp } from '@orcha/micro-library-widgets-ui';
import ApiClient from './api-client';
import { IVerifyService } from './interfaces';

@injectable()
class VerifyService implements IVerifyService {
  private apiClient: ApiClient;

  public constructor() {
    this.apiClient = new ApiClient(process.env.VERIFY_API_BASE_URL ?? '');
  }

  public async getAppSuggestions(
    searchTerm: string
  ): Promise<IVerifiedSuggestion[]> {
    const encodedSearchTerm = encodeURIComponent(searchTerm);
    const response =
      await this.apiClient.get<IVerifySuggestionsResponseWrapper>(
        `/verifiedApps?searchTerm=${encodedSearchTerm}`
      );
    return response.data?.appSuggestions ?? [];
  }

  public async getApp(appId: string): Promise<IVerifiedApp | undefined> {
    const response = await this.apiClient.get<IVerifyAppResponseWrapper>(
      `/verifiedApps/${appId}`
    );

    return response.data?.app ?? undefined;
  }
}

interface IVerifySuggestionsResponseWrapper {
  data?: IVerifySuggestionWrapper;
}
interface IVerifySuggestionWrapper {
  appSuggestions: IVerifiedSuggestion[];
}

interface IVerifyAppResponseWrapper {
  data: IVerifyAppWrapper;
}

interface IVerifyAppWrapper {
  app: IVerifiedApp | null;
}

export default VerifyService;
